import { IActionFn } from '@/store/types';
import { IModuleState, ITypeRecord } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询环境列表
export const queryEnvs: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    const allEnvs: ITypeRecord[] = store.getters['data/common/getMigrateEnvs'];
    commit('setEnvs', { data: [], loading: true });
    // const envs: string[] = await $http.get('/migration/output/environments');
    const envs: string[] = await $http.get('/v1/migration/output/environments');
    const list = allEnvs.filter((item) => envs.indexOf(item.value) > -1);
    commit('setEnvs', { data: list });
  } catch (e) {
    commit('setEnvs', { data: [] });
  }
};
